function initMask(forms){
	const phoneInputs = $(forms).find('input.js-phone-mask')
	phoneInputs.each((i, input) => {
		IMask(input, {
			mask: '+{7}(000)-000-00-00'
		});
	});
}

initMask($(".js-form"))
